import { pxToRem, spacing6 } from '@leaftrade/leaftrade-component-library';
import styled from 'styled-components';

export const TimedBannersWrapper = styled.div`
  position: fixed;
  top: ${pxToRem(70)};
  right: ${spacing6};
  z-index: 999999;
`;
